import { Container, Row, Col, Button, Spinner, Alert } from 'react-bootstrap'
import { StepHeader } from '../StepHeader/StepHeader'
import { StepperComponent } from '../../Components/StepperComponent/StepperComponent'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import config from '../../config'
import './Step1.scss'

export const Step1 = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [mondayAuthenticated, setMondayAuthenticated] = useState(false)
  const [connectionFailed, setConnectionFailed] = useState(false)
  const [authenticationFailed, setAuthenticationFailed] = useState(false)
  const [activeMigration, setActiveMigration] = useState(null)
  const [checkingMigration, setCheckingMigration] = useState(true)
  const [migrationLogs, setMigrationLogs] = useState([])
  const [selectedLogId, setSelectedLogId] = useState(null)
  const [loadingLogs, setLoadingLogs] = useState(false)

  const fetchApiKey = async (code) => {
    setLoading(true)
    try {
      const success = await fetch(`${config.BACKEND_URL}/getMondayAccessToken`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          code,
        }),
        credentials: 'include',
      })
      if (success) {
        setAuthenticationFailed(false)
        setMondayAuthenticated(true)
      } else {
        setMondayAuthenticated(false)
        setAuthenticationFailed(true)
      }
      await checkApiKey()
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log('Connection error')
      setConnectionFailed(true)
    }
  }

  const deleteCookie = async () => {
    setLoading(true)
    try {
      const resp = await fetch(`${config.BACKEND_URL}/deleteCookie`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      setLoading(false)
      if (resp.status === 200) {
        setMondayAuthenticated(false)
      }
      return resp.status
    } catch (error) {
      setLoading(false)
      console.log('Connection error', error)
      setConnectionFailed(true)
    }
  }

  const checkApiKey = async () => {
    try {
      setLoading(true)
      const data = await fetch(`${config.BACKEND_URL}/checkToken`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      }).then(async (data) => {
        const resp = await data.json()
        if (resp.success) {
          setMondayAuthenticated(true)
        } else {
          setMondayAuthenticated(false)
        }
        setLoading(false)
        return resp.success
      })
      return data
    } catch (error) {
      setLoading(false)
      console.log('Connection error', error)
      setConnectionFailed(true)
    }
  }

  const checkActiveMigration = async () => {
    try {
      const response = await fetch(`${config.BACKEND_URL}/migrate/migrationStatus`, {
        headers: {
          'ngrok-skip-browser-warning': '69420',
        },
        credentials: 'include',
      })
      if (response.ok) {
        const data = await response.json()
        // Check if there's an actual migration (not just 'no_migration' status)
        if (data.status && data.status !== 'no_migration' && 
            (data.status === 'in_progress' || data.status === 'done' || data.status === 'done_with_errors')) {
          setActiveMigration(data)
        }
      }
    } catch (error) {
      // No active migration
      console.log('No active migration found')
    } finally {
      setCheckingMigration(false)
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const code = params.get('code')
    if (code) {
      fetchApiKey(code)
    } else {
      checkApiKey()
    }
    
    // Check for active migration
    checkActiveMigration()
  }, [])

  if (loading) {
    return (
      <Container>
        <Row>
          <StepHeader />
        </Row>
        <Row>
          <Col>
            <StepperComponent currentStep={1} />
          </Col>
        </Row>
        <Row className="d-flex align-items-center justify-content-center">
          <Spinner animation="grow" variant="dark" />
        </Row>
      </Container>
    )
  }
  return (
    <Container>
      <Row>
        <StepHeader />
      </Row>
      <Row>
        <Col>
          <StepperComponent currentStep={1} />
        </Col>
      </Row>
      {/* Active Migration Alert */}
      {activeMigration && !checkingMigration && (
        <Row className="mt-3 mb-3">
          <Col xs={12} className="d-flex justify-content-center">
            <Alert variant={activeMigration.status === 'in_progress' ? 'info' : activeMigration.status === 'done' ? 'success' : 'warning'} style={{ maxWidth: '600px', width: '100%' }}>
              <Alert.Heading>
                
                {activeMigration.status === 'done' && '✅ Migration Completed'}
                {activeMigration.status === 'done_with_errors' && '⚠️ Migration Completed with Errors'}
              </Alert.Heading>
              <p className="mb-2">
              
                {activeMigration.status === 'done' && 
                  `Your migration has completed successfully. ${activeMigration.completedProjects || 0} projects migrated.`
                }
                {activeMigration.status === 'done_with_errors' && 
                  `Your migration completed with ${activeMigration.failedProjects || 0} failed projects out of ${activeMigration.totalProjects || 0}.`
                }
              </p>
              {/* <div className="d-flex gap-2">
                <Button 
                  variant={activeMigration.status === 'in_progress' ? 'primary' : 'outline-primary'}
                  size="sm" 
                  onClick={() => navigate('/step6')}
                >
                  {activeMigration.status === 'in_progress' ? 'View Migration Status' : 'View Results'}
                </Button>
                {activeMigration.status !== 'in_progress' && (
                  <Button 
                    variant="outline-secondary"
                    size="sm" 
                    onClick={async () => {
                      await fetch(`${config.BACKEND_URL}/migrate/migrationStatus`, {
                        method: 'DELETE',
                        headers: {
                          'ngrok-skip-browser-warning': '69420',
                        },
                        credentials: 'include',
                      })
                      setActiveMigration(null)
                    }}
                  >
                    Clear & Start New
                  </Button>
                )}
              </div> */}
            </Alert>
          </Col>
        </Row>
      )}

      <Row className={'justify-content-center align-items-center'}>
        {/* <Col md={2} /> */}
        <Col xs={12} md={6} className={'text-center text-md-end mb-3'}>
          <Button
            onClick={() => {
              window.open(
                'https://capabilitysource.monday.com/oauth2/authorize?client_id=ce6d15e6ddfa710c4c6c35f65a696ece',
                '_self',
              )
            }}
            disabled={mondayAuthenticated}
            className={'mondayConnectionButton'}
          >
            Connect to Monday
          </Button>
        </Col>
        <Col xs={12} md={6} className={'text-left'}>
          {mondayAuthenticated && (
            <span
              style={{ color: `${mondayAuthenticated && 'green'}` }}
              className={'connectionStatusText align-top'}
            >
              {'Success'}
            </span>
          )}

          {connectionFailed && (
            <span
              style={{ color: `${connectionFailed && 'red'}` }}
              className={'connectionStatusText align-top'}
            >
              {'Connection failed'}
            </span>
          )}
          {authenticationFailed && (
            <span
              style={{ color: `${authenticationFailed && 'red'}` }}
              className={'connectionStatusText align-top'}
            >
              {'Authentication failed'}
            </span>
          )}
        </Col>
        <Col xs={12} md={6} className={'text-center text-md-end mt-3 mt-md-0'}>
          {mondayAuthenticated && (
            <Button
              onClick={async () => {
                await deleteCookie()
                window.open(window.location.href.split('?code')[0], '_self')
              }}
              disabled={!mondayAuthenticated}
              className={'mondayConnectionButton'}
            >
              Disconect
            </Button>
          )}
        </Col>
        <Col xs={12} md={6}></Col>
      </Row>
      <Row className="mt-3">
        <Col xs={6} md={5} />
        <Col
          xs={5}
          md={5}
          className="d-flex flex-wrap align-items-center justify-content-between justify-content-lg-start"
        ></Col>
      </Row>
      <Row className={'mt-5'}>
        <Col xs={10} className={'d-flex justify-content-end'}>
          <Button className={'me-4'} onClick={() => navigate('/')}>
            <b>Back</b>
          </Button>
          <Button
            disabled={!mondayAuthenticated}
            onClick={() => {
              navigate('/step2')
            }}
          >
            Next
          </Button>
        </Col>
      </Row>
    </Container>
  )
}
